<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="attente">
    <NavBar />
    <div class="timeCounter" v-if="seen">
      <p>Prochaine immersion dans :</p>
      <ul>
        <li>
          <span>{{ days }}</span
          >jours
        </li>
        <li>
          <span>{{ hours }}</span
          >heures
        </li>
        <li>
          <span>{{ minutes }}</span
          >minutes
        </li>
        <li>
          <span>{{ seconds }}</span
          >secondes
        </li>
      </ul>
    </div>
    <img id="character-2" class="character" width="130" src="https://cdn.exploreve.fr/content/personnages/erwin.svg" />
    <img id="character-1" class="character" width="350" src="https://cdn.exploreve.fr/content/personnages/daria.svg" />

    <div id="ellipse-1" class="ellipse"></div>
    <div id="ellipse-2" class="ellipse"></div>

    <div class="talk">
      <div class="talk-arrow"></div>
      <h1 class="title">Erwin :</h1>
      <p>Désolé, Léon est encore en train de bricoler le Ballon-Songe.</p>
      <p>Reviens dans quelques jours et nous serons sans-doute prêt pour un nouveau voyage dans la Troposphère !</p>
    </div>
    <FinishedList />

    <NewsletterForm class="news" />

    <img class="ballon" width="250" src="https://cdn.exploreve.fr/content/ballons/ballon_rouge.svg" />

    <div id="cloud-1" class="cloud"></div>
    <div id="cloud-2" class="cloud"></div>
    <div id="cloud-3" class="cloud"></div>
    <div id="cloud-4" class="cloud"></div>

    <router-view />
  </div>
</template>

<style>
.news {
  position: absolute;
  left: 46%;
  width: 300px !important;
  bottom: 3% !important;
  z-index: 10;
}
.finished-list {
  position: absolute;
  right: 10vw;
  top: 15%;
  z-index: 10;
  width: 15vw;
}

.finished-list button {
  width: 15vw;
  margin-bottom: 10px !important;
}

.timeCounter {
  display: block;
  position: absolute;
  bottom: 10vh;
  right: 10vw;
  z-index: 10;
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
}
.timeCounter ul {
  padding-inline-start: 0;
  margin: 0;
}
.timeCounter li {
  display: inline-block;
  font-size: 0.7em;
  list-style-type: none;
  padding: 10px;
}
.timeCounter li span {
  display: block;
  font-size: 1.5rem;
  text-align: center;
}
.timeCounter p {
  margin-bottom: 0;
}

h1.title {
  margin-top: 0px !important;
}

div.ellipse {
  background: #fcedd9;
  border-radius: 50%;
  position: fixed;
  z-index: 0;
}

div.ellipse#ellipse-1 {
  width: 350px;
  height: 130px;
  bottom: 13%;
  left: 5%;
}

div.ellipse#ellipse-2 {
  width: 280px;
  height: 100px;
  bottom: 24%;
  left: 24%;
}

img.character {
  z-index: 1;
  position: absolute;
}

img#character-1 {
  bottom: 20%;
  left: 7.5%;
}

img#character-2 {
  bottom: 30%;
  left: 30%;
}

div.talk {
  text-align: left;
  background: white;
  border-radius: 10px;
  width: 300px;
  font-size: 20px;
  padding: 24px;
  position: absolute;
  left: 46%;
  top: 15%;
  z-index: 10;
}

div.talk-arrow {
  width: 0;
  height: 0;
  border-right: 50px solid white;
  border-bottom: 20px solid transparent;
  border-top: 20px solid transparent;
  position: absolute;
  left: -50px;
  top: 20%;
}

img.ballon {
  position: absolute;
  top: -15%;
  right: 10%;
  z-index: 5;
}

div.cloud {
  background: #fcedd9;
  border-radius: 180px;
  position: absolute;
  opacity: 0.7;
}

div.cloud#cloud-1 {
  height: 120px;
  width: 300px;
  right: 0;
  top: 45%;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 6;
}

div.cloud#cloud-2 {
  width: 180px;
  height: 40px;
  z-index: 6;
  right: 0;
  top: 10%;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

div.cloud#cloud-3 {
  width: 400px;
  height: 100px;
  z-index: -1;
  right: 50%;
  top: 30%;
}

div.cloud#cloud-4 {
  width: 300px;
  height: 100px;
  z-index: -1;
  right: 25%;
  top: 20%;
}
@media screen and (min-width: 1920px) and (min-height: 1080px) {
  .bloc {
    display: block;
    clear: both;
  }
}
</style>

<script>
// @ is an alias to /src
import NavBar from "@/components/NavBar.vue";
import NewsletterForm from "@/components/NewsletterForm.vue";
import FinishedList from "@/components/FinishedList.vue";
let interval = null;
export default {
  name: "attente",
  data: function () {
    return {
      /*Rentrer la date de publication ci-dessous*/
      date: Math.trunc(new Date("April 4, 2020, 20:00:00").getTime() / 1000),
      now: Math.trunc(new Date().getTime() / 1000),
      diff: 0,
      seen: false
    };
  },
  created() {
    interval = setInterval(() => {
      this.now = Math.trunc(new Date().getTime() / 1000);
    }, 1000);
  },
  computed: {
    seconds() {
      return Math.trunc(this.diff) % 60;
    },
    minutes() {
      return Math.trunc(this.diff / 60) % 60;
    },
    hours() {
      return Math.trunc(this.diff / 60 / 60) % 24;
    },
    days() {
      return Math.trunc(this.diff / 60 / 60 / 24);
    }
  },
  watch: {
    now() {
      this.diff = this.date - this.now;
      if (this.diff <= 0) {
        this.diff = 0;
        clearInterval(interval);
      }
    }
  },
  components: {
    NavBar,
    NewsletterForm,
    FinishedList
  }
};
</script>
